var $menu;
var $menuContainer;
var albumTemplate, showTemplate;
var $albumItemlist, $showItemlist;

$(function(){
    $menu = $('#menu');
    $menuContainer = $('#menu__container');

    albumTemplate = $("#template--album").html();
    showTemplate = $("#template--show").html();
    $albumItemlist = $("#anchor-records .albumlist");
    $showItemlist = $("#anchor-shows .showlist");

    /**
    * # Toggle menu #
    * Gère l'affichage des éléments ayant un attribut data-target valide
    * data-target représente un sélecteur CSS de l'élément à masquer/afficher
    */
    $('#menu__btn').on('click', function(e){
        e.preventDefault();

        if($menuContainer.css('display') == 'none'){
            $(this).addClass('active');
            $menuContainer.css({ display : 'block' }).animate({
                opacity : 1,
                height : '100vh'
            }, 200);
        }
        else{
            $(this).removeClass('active');
            $menuContainer.animate({
                opacity : 0,
                height : 0
            }, 200, function(){
                $(this).css({ display : 'none' })
            });
        }
    });


    /**
    * Chargement des ALBUMS depuis le fichier JSON
    */
    var appendImage = function(){
        $('#item-'+this.index+' .placeholder').append(this);
    };

    $.getJSON('./json/albums.json', function(data){
        for(var i = 0, n = data.length; i < n; i++){
            var $item = $(albumTemplate);
            $albumItemlist.append($item);

            var $placeholder = $item.find('.placeholder');
            $item.attr('id', 'item-'+i);
            $placeholder.css({ height : $item.width() + 'px' });

            var image = new Image();
            image.alt = data[i].name;
            image.index = i;

            image.onload = appendImage;
            image.src = data[i].cover;

            $item.find('figcaption .album__title').text(data[i].name);
            $item.find('figcaption .album__year').text(data[i].year);
            $item.find('figcaption .album__artist').text(data[i].artist);
        }
    });

    $(window).on('resize', function(){
        $('.album .placeholder').each(function(){
            $(this).css({ height : $(this).width() + 'px' });
        });
    });

    /**
    * Chargement des SHOWS depuis le fichier JSON
    */
    $.getJSON('./json/shows.json', function(data){
        for(var i = 0, n = data.length; i < n; i++){
            var $item = $(showTemplate);
            $showItemlist.append($item);

            $item.attr('id', 'item-'+i);
            $item.find('.details__title--content').text(data[i].location + ' - ' + data[i].name);
            $item.find('.details__description').text(data[i].description);
            $item.find('.show__date--month-day').text(data[i].day + ' ' + data[i].month);
            $item.find('.show__date--year').text(data[i].year);
            if(data[i].rescheduled) $item.find('.details__title--rescheduled').addClass("active");
        }
    });

    Slider.init({
        feed : './json/slider.json',
        speed : 4000
    });
});
